import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { inject, NgModule } from '@angular/core';
import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core';
import { SessionStorageService } from 'ngx-webstorage';
import { setContext } from '@apollo/client/link/context';
import { environment } from 'src/environments/environment';
import { OidcSecurityService } from 'angular-auth-oidc-client';

export function createApollo(): ApolloClientOptions<any> {
  const uri = environment.graphqlUrl;
  const httpLink = inject(HttpLink);
  const sessionStorage = inject(SessionStorageService);
  const oidcSecurityService = inject(OidcSecurityService);

  // Create an HttpLink instance pointing to your GraphQL endpoint
  const http = httpLink.create({ uri });

  // Create an Apollo Link to set the context (including headers)
  // This runs for EACH request, so the token is always fresh
  const authLink = setContext(async (_, { headers }) => {
    // Try to get token from session storage first
    let token = sessionStorage.retrieve('authToken');

    // If not in session storage, try to get it from OIDC service
    if (!token) {
      token = oidcSecurityService.getAccessToken();

      // Store it for future use
      if (token) {
        sessionStorage.store('authToken', token);
      }
    }

    // Return the headers to be added to the request
    if (token) {
      return {
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      };
    }

    return { headers };
  });

  // Combine the authLink and httpLink
  const link = authLink.concat(http);

  return {
    link: link,
    cache: new InMemoryCache(),
  };
}

@NgModule({
  providers: [provideApollo(createApollo)],
})
export class GraphQLModule { }
